import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
const {
  introduction: { path },
} = routes;
const IntroductionRoute = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "introduction" */ "./Introduction"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
export default IntroductionRoute;
